import React from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const BulletCard = ({ heading, bulletPoints }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  return (
    <>
      <div className="next-steps-card">
        <h2 className="section-heading">{heading}</h2>
        <ul className="steps-list">
          {bulletPoints?.map((point, index) => (
            <li>
              <span>{index + 1}</span>{" "}
              {t(`${routeName}.${point?.label}`, { hour: 4 })}
            </li>
          ))}
        </ul>
      </div>

      <div class="referral-card">
        <label class="referral-title">Share your referral code:</label>
        <div class="referral-input-wrapper">
          <input class="referral-code" type="text" value="TOYOTA25" readonly />
          <button class="copy-button" aria-label="Copy code">
            📋
          </button>
        </div>
        <p class="referral-description">
          Share with friends to move up the waitlist and earn exclusive bonuses
        </p>
      </div>
    </>
  );
};

export default BulletCard;
